import styled from 'styled-components';

export default styled.div`
	.motif-tab-navigation .motif-tab-button {
		line-height: var(--px-20);
	}
`;
